/* CSS HEX */
export const darkBlue = '#11151cff';
export const blue = '#212d40ff';
export const charcoal = '#364156ff';
export const purple = '#7d4e57ff';
export const coral = '#d66853ff';